<template>
  <main id="commissions-list" class="site-main">
    <div class="grid-container">
      <div class="grid-x grid-padding-x">
        <div class="cell">
          <div class="grid-x grid-padding-x">
            <div class="welcome cell large-auto">
              <div class="welcome__title">{{ welcomeMessage }},
                <span v-if="!$store.state.vendors[$store.state.currentVendor].contact_name || $store.state.vendors[$store.state.currentVendor].contact_name.length === 0">{{ $store.state.vendors[$store.state.currentVendor].name }}</span>
                <span v-if="$store.state.vendors[$store.state.currentVendor].contact_name && $store.state.vendors[$store.state.currentVendor].contact_name.length > 0">{{ $store.state.vendors[$store.state.currentVendor].contact_name }}</span>
              </div>

              <div class="welcome__content">
                <p v-if="$store.state.portalSettings.myshopify_domain === 'inuitbookshop.myshopify.com'">qui puoi vedere cosa hai venduto da Inuit ☻</p>
                <p v-else>Welcome to our new vendor portal!</p>
              </div>
            </div>

            <div class="stats cell large-shrink" v-if="$store.state.portalSettings.myshopify_domain !== 'the-makers-mark.myshopify.com' && $store.state.portalSettings.myshopify_domain !== 'shop-boutique-collective.myshopify.com' && $store.state.portalSettings.myshopify_domain !== 'localview.myshopify.com'">
              <div>
                <div class="grid-x">
                  <div class="cell auto label warning">
                    <div class="label__heading">Owed</div>
                    <div class="label__content">{{ commissionDue }}</div>
                  </div>

                  <div class="cell auto label success">
                    <div class="label__heading">Paid</div>
                    <div class="label__content">{{ commissionPaid }}</div>
                  </div>

                  <div class="cell auto label">
                    <div class="label__heading">Earned</div>
                    <div class="label__content">{{ commissionEarned }}</div>
                  </div>

                  <div class="cell auto label" v-if="$store.state.portalSettings.myshopify_domain === 'cutting-tool-pickers-1.myshopify.com'">
                    <div class="label__heading">Sales</div>
                    <div class="label__content">{{ totalSales }}</div>
                  </div>

                  <div class="cell auto label" v-if="$store.state.portalSettings.myshopify_domain === 'royal-bison-fair.myshopify.com'">
                    <div class="label__heading">Taxes</div>
                    <div class="label__content">{{ taxes }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="list-actions text-right">
        <span class="icon-action" @click="exportCommissions">
          <i class="far fa-arrow-to-bottom"></i> <span>Export</span>
        </span>
      </div>

      <div class="panel no-padding">
        <searchBar placeholder="Search line items" @sort="sort"
                   :value="searchValue" :dateFilter="true"
                   :paidFilter="true"
                   @search="search" @dateFilter="dateFilter"
                   @paidFilter="paidFilter"></searchBar>

        <div :class="['loading-area', loading ? 'loading' : '']">
          <div :class="['loading-area__content', loading ? 'loading' : '']">
            <pagination :prev="prev" :next="next" :start="start" :end="end"
                        :total="total" @paginate="paginate"></pagination>

            <div style="overflow: scroll;">
              <tableList :header="tableHeader" :data="tableData" :mobileHeader="true"
                         :loading="loading"
                         classes="no-hover" @sort="orderBy" style="min-width: 1000px;"
                         @callback="callback"></tableList>
            </div>

            <pagination :prev="prev" :next="next" :start="start" :end="end"
                        :total="total" @paginate="paginate"></pagination>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import pagination from '@/globals/pagination'
import tableList from '@/globals/tableList'
import paginationUtils from '@/mixins/paginationUtils'
import payout from '@/globals/payout'
import moment from 'moment'

export default {
  mixins: [paginationUtils],
  components: {
    pagination,
    tableList,
    payout
  },
  data: function () {
    return {
      order: {
        name: '#0000',
        url: '#'
      },
      date: 'Jan 1, 1970 at 0:00am',
      financialLabel: '',
      financialStatus: 'Payment',
      fulfillmentLabel: '',
      fulfillmentStatus: 'Fulfillment',
      price: 0,
      action: '/vendors/commissions/?vendor_id=' + this.$store.state.vendors[this.$store.state.currentVendor].id + '&shop_id=' + this.$store.state.portalSettings.shop_id,
      params: {},
      sort: '-order__processed_at',
      tableHeader: {
        checkboxColumn: true,
        data: [
          {
            label: 'Order'
          },
          {
            label: 'Product',
            class: 'full'
          },
          {
            label: 'SKU',
            class: 'large'
          },
          {
            label: 'Location',
            class: 'medium'
          },
          {
            label: 'Customer',
            class: 'medium show-for-xlarge'
          },
          {
            label: 'Barcode'
          },
          // {
          //   label: 'Fulfillment',
          //   class: 'medium'
          // },
          {
            label: 'Item Cost',
            class: 'show-for-xlarge'
          },
          {
            label: 'Price'
          },
          {
            label: 'HST'
          },
          {
            label: 'Owed'
          },
          {
            label: 'Product Code',
            class: 'medium'
          },
          {
            label: 'Date',
            class: 'large show-for-xlarge'
          }
        ]
      },
      tableData: [],
      commissionDue: 0,
      commissionPaid: 0,
      commissionEarned: 0,
      totalSales: 0,
      taxes: 0,
      welcomeMessage: ''
    }
  },
  methods: {
    exportCommissions () {
      this.loading = true

      let omitFields = 'sku,barcode,item_cost'

      if (this.$store.state.portalSettings.myshopify_domain === 'qualityfood.myshopify.com') {
        omitFields = ''
      }

      if (this.$store.state.portalSettings.myshopify_domain === 'outletspecialist-bv.myshopify.com') {
        omitFields = 'barcode,item_cost'
      }

      this.request('get', '/vendors/commissions/', {
        vendor_id: this.$store.state.vendors[this.$store.state.currentVendor].id,
        paid: this.params['paid'],
        date_start: this.params['date_start'],
        date_end: this.params['date_end'],
        ordering: '-order__processed_at',
        format: 'csv',
        omit: omitFields
      }).then((response) => {
        let downloadLink = document.createElement('a')

        downloadLink.href = response
        downloadLink.target = '_blank'

        document.body.appendChild(downloadLink)
        downloadLink.click()
        document.body.removeChild(downloadLink)

        this.loading = false
      })
    },
    dateFilter (startDate, endDate) {
      if (startDate.length > 0) {
        this.params['date_start'] = startDate
      } else {
        delete this.params['date_start']
      }

      if (endDate.length > 0) {
        this.params['date_end'] = endDate
      } else {
        delete this.params['date_end']
      }

      this.getData()
    },
    paidFilter (paid) {
      if (paid !== null) {
        this.params['paid'] = paid
      } else {
        delete this.params['paid']
      }

      this.getData()
    },
    buildTable () {
      let lineItems = this.data

      for (let i = 0; i < lineItems.length; i++) {
        lineItems[i].date = moment(lineItems[i].order.processed_at).format('MMM D, YYYY [at] h:mma')
        lineItems[i].financial_status = 'paid'
        lineItems[i].financialLabel = 'success'
        lineItems[i].customer_name = 'N/A'

        this.price = this.formatMoney(this.data.price)

        lineItems[i].fulfillmentStatus = lineItems[i].fulfillment_status

        if (lineItems[i].fulfillment_status === 'partial') {
          lineItems[i].fulfillmentLabel = 'warning'
          lineItems[i].fulfillmentStatus = 'Partially Fulfilled'
        } else if (lineItems[i].fulfillment_status === 'restocked' ||
          lineItems[i].fulfillment_status === null) {
          lineItems[i].fulfillmentLabel = 'alert'
        } else {
          lineItems[i].fulfillmentLabel = 'success'
        }

        if (lineItems[i].fulfillment_status === null) {
          lineItems[i].fulfillmentStatus = 'Unfulfilled'
        }

        lineItems[i].fulfillmentStatus = this.formatText(lineItems[i].fulfillmentStatus)

        let title = ''

        if (lineItems[i].variant !== null) {
          title = lineItems[i].variant.product.title
        } else {
          if (lineItems[i].title !== null && lineItems[i].title.length > 0) {
            title = lineItems[i].title
          } else {
            title = lineItems[i].name
          }
        }

        let primary = '<div class="grid-x align-middle" title="' + title + '"><div class="cell shrink">' +
          '<div class="table-list__image">'

        if (lineItems[i].variant && !this.isEmpty(lineItems[i].variant.image) && lineItems[i].variant.image !== undefined && lineItems[i].variant.image.src !== undefined) {
          primary += '<div class="table-list__image__inner">'
          primary += '<img src="' + lineItems[i].variant.image.src + '">'
          primary += '</div>'
        } else if (lineItems[i].image.length > 0) {
          primary += '<div class="table-list__image__inner">'
          primary += '<img src="' + lineItems[i].image + '">'
          primary += '</div>'
        } else {
          primary += '<div class="table-list__image__missing"><i class="fas fa-image"></i></div>'
        }

        if (lineItems[i].variant !== null) {
          if (lineItems[i].variant.product !== null) {
            primary += '</div></div><div class="cell auto"><span>' + lineItems[i].variant.product.title + '</span>'
          } else {
            primary += '</div></div><div class="cell auto">'
          }

          if (lineItems[i].variant !== null && lineItems[i].variant.title !== null && lineItems[i].variant.title.length > 0 && lineItems[i].variant.title !== 'Default Title') {
            primary += '<br><span><small><i>' + lineItems[i].variant.title + '</i></small></span>'
          }
        } else {
          primary += '</div></div><div class="cell auto">'

          if (lineItems[i].title !== null && lineItems[i].title.length > 0 && this.$store.state.portalSettings.myshopify_domain !== 'tnaa1k-9c.myshopify.com') {
            primary += '<span>' + lineItems[i].title + '</span>'
          } else {
            if (lineItems[i].name !== null) {
              primary += '<span>' + lineItems[i].name + '</span>'
            } else {
              primary += '<span>' + lineItems[i].title + '</span>'
            }
          }
        }

        if (lineItems[i].sku !== null && lineItems[i].sku.length > 0) {
          primary += '<br><span class="text-overflow"><small><i>' + lineItems[i].sku + '</i></small></span>'
        }

        primary += '</div></div>'

        let priceCol = {}

        if (this.metas.vendor_field_sell_price.meta_value !== false) {
          let price = '<div class="grid-x align-middle"><div class="cell shrink">' + this.formatMoney(lineItems[i].price)

          if (this.metas.vendor_field_discount.meta_value !== false && lineItems[i].allocated_discount > 0) {
            price += '<div class="text-right">-' + this.formatMoney(lineItems[i].allocated_discount) + '</div>'
          }

          if (this.$store.state.portalSettings.myshopify_domain === 'mostlymusic.myshopify.com') {
            price += '</div><div class="cell auto text-right" style="white-space: nowrap;"></div></div>'
          } else {
            price += '</div><div class="cell auto text-right" style="white-space: nowrap;">x ' + lineItems[i].quantity + '</div></div>'
          }

          priceCol = {
            value: price,
            span: 'fill'
          }
        }

        if (this.$store.state.portalSettings.myshopify_domain === 'stylecolab-preloved.myshopify.com') {
          let price = lineItems[i].price

          if (lineItems[i].allocated_discount > 0) {
            price -= lineItems[i].allocated_discount
          }

          priceCol = {
            value: this.formatMoney(price),
            span: 'fill'
          }
        }

        let checkbox = ''
        let commissionCol = {}

        if (this.metas.vendor_field_commissions.meta_value !== false) {
          let commission = this.formatMoney(lineItems[i].commission_amount)

          commissionCol = {
            value: commission,
            span: 'focus-text'
          }

          if (lineItems[i].commission_type === 'override') {
            commission = '*' + commission

            commissionCol['value'] = commission
            commissionCol['callbackArgs'] = [lineItems[i], lineItems[i].commission_amount.toFixed(2)]
          }
        }

        if (lineItems[i].vendor_paid) {
          checkbox = 'PAID'
        }

        let order = {}

        if (this.metas.vendor_field_order_num.meta_value !== false) {
          order = {
            value: lineItems[i].order.name,
            span: 'focus-text'
          }
        }

        let date = {}

        if (this.metas.vendor_field_order_date.meta_value !== false) {
          date = {
            value: lineItems[i].date,
            class: 'large'
          }
        }

        let customer = {}

        if (this.metas.vendor_field_customer_name.meta_value === true) {
          customer = {
            value: lineItems[i].order.customer_name,
            class: 'medium'
          }
        }

        let barcodeCol = {}
        let costCol = {}

        let costPerItem = 0.0

        if (lineItems[i].variant && lineItems[i].variant.cost_per_item) {
          costPerItem = lineItems[i].variant.cost_per_item
        }

        if (this.$store.state.portalSettings.myshopify_domain === 'qualityfood.myshopify.com' || this.$store.state.portalSettings.myshopify_domain === 'specialguestapp.myshopify.com') {
          barcodeCol = {
            value: lineItems[i].variant.barcode
          }

          costCol = {
            value: this.formatMoney(costPerItem),
            span: 'fill'
            // class: 'show-for-xlarge'
          }
        }

        if (this.$store.state.portalSettings.myshopify_domain === 'renee-taylor-gallery.myshopify.com') {
          barcodeCol = {
            value: lineItems[i].variant.barcode
          }
        }

        let locationCol = {
          value: '',
          class: 'medium'
        }

        if (lineItems[i].order.location) {
          locationCol['value'] = lineItems[i].order.location.name
        }

        if (this.$store.state.portalSettings.myshopify_domain !== 'it-takes-a-village-co.myshopify.com') {
          locationCol = {}
        } else {
          costCol = {}
        }

        if (this.$store.state.portalSettings.myshopify_domain === 'blast-team-stores.myshopify.com') {
          costCol = {}
        }

        let skuCol = {}

        if (this.$store.state.portalSettings.myshopify_domain === 'kina-11.myshopify.com' || this.$store.state.portalSettings.myshopify_domain === 'kingsroy-gallery.myshopify.com') {
          skuCol = {
            value: lineItems[i].sku,
            class: 'large'
          }
        }

        let companyCol = {}

        if (lineItems[i].order.customer_company) {
          companyCol = {
            'value': lineItems[i].order.customer_company,
            'class': 'large'
          }
        }

        let hstCol = {}

        if ((this.$store.state.portalSettings.myshopify_domain === 'forrest-harbour-co.myshopify.com' || this.$store.state.portalSettings.myshopify_domain === 'locke-street.myshopify.com') && this.$store.state.vendors[this.$store.state.currentVendor].collects_tax) {
          hstCol = {
            value: this.formatMoney(lineItems[i].total_tax * lineItems[i].commission_rate)
          }
        }

        let productCodeCol = {}
        if (this.$store.state.portalSettings.myshopify_domain === 'outletspecialist-bv.myshopify.com') {
          let productTags = lineItems[i].variant.product.tags.split(',')

          let productCode = ''

          for (let i = 0; i < productTags.length; i++) {
            if (productTags[i].indexOf('Productcodeleverancier_') !== -1) {
              productCode = productTags[i].replace('Productcodeleverancier_', '')
            }
          }

          productCodeCol = {
            value: productCode,
            class: 'medium'
          }
        }

        let tableData = {
          post: lineItems[i].id,
          checkbox: checkbox,
          data: [
            order,
            {
              value: primary,
              class: 'full'
            },
            skuCol,
            barcodeCol,
            customer,
            locationCol,
            costCol,
            priceCol,
            hstCol,
            commissionCol,
            productCodeCol,
            date
          ]
        }

        if (this.$store.state.appSettings['commission_fields'] && (this.$store.state.portalSettings.myshopify_domain === 'new-dimension-books.myshopify.com' || this.$store.state.portalSettings.myshopify_domain === 'handmadesaskyxe.myshopify.com' || this.$store.state.portalSettings.myshopify_domain === 'handmadesask.myshopify.com' || this.$store.state.portalSettings.myshopify_domain === 'kina-11.myshopify.com' || this.$store.state.portalSettings.myshopify_domain === 'kingsroy-gallery.myshopify.com')) {
          tableData['data'] = []

          let price = lineItems[i].price

          priceCol = {
            value: this.formatMoney(price),
            span: 'shrink'
          }

          let costCol = {
            value: this.formatMoney(costPerItem),
            span: 'fill'
          }

          let locationCol = {
            value: '',
            class: 'medium'
          }

          if (lineItems[i].order.location) {
            locationCol['value'] = lineItems[i].order.location.name
          }

          let quantityCol = {
            value: lineItems[i].quantity,
            class: 'medium'
          }

          for (let i = 0; i < this.appSettings['commission_fields'].length; i++) {
            let field = this.appSettings['commission_fields'][i]
            let col = ''

            switch (field['key']) {
              case 'order_number':
                col = order
                break
              case 'product':
                col = {
                  value: primary,
                  class: 'full'
                }
                break
              case 'price':
                col = priceCol
                break
              case 'commission':
                col = commissionCol
                break
              case 'date':
                col = date
                break
              case 'sku':
                col = skuCol
                break
              case 'barcode':
                col = barcodeCol
                break
              case 'item_cost':
                col = costCol
                break
              case 'customer':
                col = customer
                break
              case 'company':
                col = companyCol
                break
              case 'location':
                col = locationCol
                break
              case 'quantity':
                col = quantityCol
                break
            }

            tableData['data'].push(col)
          }
        }

        this.tableData.push(tableData)
      }

      // for (let i = 0; i < this.tableData.length; i++) {
      //   this.request('get', '/vendors/' + this.tableData[i].vendor + '/').then(response => {
      //     this.tableData[i].data.pop()
      //   })
      // }
    }
  },
  computed: {
    appSettings () {
      return this.$store.state.appSettings
    },
    settings () {
      return this.$store.state.settings
    },
    metas () {
      return this.$store.state.metas
    }
  },
  created: function () {
    if ((this.$store.state.portalSettings.myshopify_domain !== 'forrest-harbour-co.myshopify.com' && this.$store.state.portalSettings.myshopify_domain !== 'locke-street.myshopify.com') || !this.$store.state.vendors[this.$store.state.currentVendor].collects_tax) {
      for (let i = 0; i < this.tableHeader.data.length; i++) {
        if (this.tableHeader.data[i].label === 'HST') {
          this.tableHeader.data[i] = {}
        }
      }
    }

    if (this.$store.state.portalSettings.myshopify_domain !== 'outletspecialist-bv.myshopify.com') {
      for (let i = 0; i < this.tableHeader.data.length; i++) {
        if (this.tableHeader.data[i].label === 'Product Code') {
          this.tableHeader.data[i] = {}
        }
      }
    }

    if (this.$store.state.portalSettings.myshopify_domain !== 'qualityfood.myshopify.com') {
      for (let i = 0; i < this.tableHeader.data.length; i++) {
        if (this.tableHeader.data[i].label === 'Customer') {
          this.tableHeader.data[i] = {}
        }
      }
    }

    if (this.$store.state.portalSettings.myshopify_domain !== 'it-takes-a-village-co.myshopify.com') {
      for (let i = 0; i < this.tableHeader.data.length; i++) {
        if (this.tableHeader.data[i].label === 'Location') {
          this.tableHeader.data[i] = {}
        }
      }

      for (let i = 0; i < this.tableHeader.data.length; i++) {
        if (this.tableHeader.data[i].label === 'Item Cost') {
          this.tableHeader.data[i] = {}
        }
      }
    } else {
      for (let i = 0; i < this.tableHeader.data.length; i++) {
        if (this.tableHeader.data[i].label === 'Item Cost') {
          this.tableHeader.data[i] = {}
        }
      }
    }

    if (this.metas.vendor_field_sell_price.meta_value === false) {
      for (let i = 0; i < this.tableHeader.data.length; i++) {
        if (this.tableHeader.data[i].label === 'Price') {
          this.tableHeader.data[i] = {}
        }
      }
    }

    if (this.metas.vendor_field_commissions.meta_value === false) {
      for (let i = 0; i < this.tableHeader.data.length; i++) {
        if (this.tableHeader.data[i].label === 'Commission') {
          this.tableHeader.data[i] = {}
        }
      }
    }

    if (this.metas.vendor_field_order_num.meta_value === false) {
      for (let i = 0; i < this.tableHeader.data.length; i++) {
        if (this.tableHeader.data[i].label === 'Order') {
          this.tableHeader.data[i] = {}
        }
      }
    }

    if (this.metas.vendor_field_order_date.meta_value === false) {
      for (let i = 0; i < this.tableHeader.data.length; i++) {
        if (this.tableHeader.data[i].label === 'Date') {
          this.tableHeader.data[i] = {}
        }
      }
    }

    if (this.metas.vendor_field_customer_name.meta_value === false || this.metas.vendor_field_customer_name.meta_value.length === 0) {
      for (let i = 0; i < this.tableHeader.data.length; i++) {
        if (this.tableHeader.data[i].label === 'Customer') {
          this.tableHeader.data[i] = {}
        }
      }
    }

    if (this.$store.state.portalSettings.myshopify_domain !== 'qualityfood.myshopify.com' && this.$store.state.portalSettings.myshopify_domain !== 'renee-taylor-gallery.myshopify.com') {
      for (let i = 0; i < this.tableHeader.data.length; i++) {
        if (this.tableHeader.data[i].label === 'Barcode') {
          this.tableHeader.data[i] = {}
        }
      }
    }

    if (this.$store.state.portalSettings.myshopify_domain === 'blast-team-stores.myshopify.com') {
      for (let i = 0; i < this.tableHeader.data.length; i++) {
        if (this.tableHeader.data[i].label === 'Item Cost') {
          this.tableHeader.data[i] = {}
        }
      }
    }

    if (this.$store.state.portalSettings.myshopify_domain === 'kina-11.myshopify.com' || this.$store.state.portalSettings.myshopify_domain === 'kingsroy-gallery.myshopify.com') {

    } else {
      for (let i = 0; i < this.tableHeader.data.length; i++) {
        if (this.tableHeader.data[i].label === 'SKU') {
          this.tableHeader.data[i] = {}
        }
      }
    }

    if (this.$store.state.appSettings['commission_fields'] && (this.$store.state.portalSettings.myshopify_domain === 'new-dimension-books.myshopify.com' || this.$store.state.portalSettings.myshopify_domain === 'handmadesaskyxe.myshopify.com' || this.$store.state.portalSettings.myshopify_domain === 'handmadesask.myshopify.com' || this.$store.state.portalSettings.myshopify_domain === 'kina-11.myshopify.com' || this.$store.state.portalSettings.myshopify_domain === 'kingsroy-gallery.myshopify.com')) {
      this.tableHeader.data = []

      for (let i = 0; i < this.appSettings['commission_fields'].length; i++) {
        let field = this.appSettings['commission_fields'][i]

        let col = {
          'label': field['label']
        }

        switch (field['key']) {
          case 'order_number':
            // col['class'] = 'full'
            break
          case 'product':
            col['class'] = 'full'
            break
          case 'price':
            // col['class'] = 'full'
            break
          case 'commission':
            // col['class'] = 'full'
            break
          case 'date':
            col['class'] = 'large'
            break
          case 'sku':
            col['class'] = 'large'
            break
          case 'barcode':
            // col['class'] = 'full'
            break
          case 'item_cost':
            // col['class'] = 'full'
            break
          case 'customer':
            col['class'] = 'medium'
            break
          case 'company':
            col['class'] = 'large'
            break
          case 'location':
            col['class'] = 'medium'
            break
          case 'quantity':
            col['class'] = 'medium'
            break
        }

        this.tableHeader.data.push(col)
      }
    }

    this.getData()

    this.commissionDue = this.formatMoney(0)
    this.commissionPaid = this.formatMoney(0)
    this.commissionEarned = this.formatMoney(0)
    this.taxes = this.formatMoney(0)

    let date = new Date()
    let hours = date.getHours()
    this.welcomeMessage = hours < 12 ? 'Good Morning' : hours < 18 ? 'Good Afternoon' : 'Good Evening'

    if (this.$store.state.portalSettings.myshopify_domain === 'inuitbookshop.myshopify.com') {
      this.welcomeMessage = 'Ciao'
    }

    this.request('get', '/vendors/recalculate-totals/?shop_id=' + this.$store.state.portalSettings.shop_id + '&vendor_id=' + this.$store.state.vendors[this.$store.state.currentVendor].id).then(response => {
      this.request('get', '/vendors/commission-totals/' + this.$store.state.vendors[this.$store.state.currentVendor].id + '/').then(response => {
        this.commissionDue = this.formatMoney(response.commission_due)
        this.commissionPaid = this.formatMoney(response.commission_paid)
        this.commissionEarned = this.formatMoney(response.commission_earned)
        this.totalSales = this.formatMoney(response.total_sales)
        this.taxes = this.formatMoney(response.amount_taxed)
      })
    })
  }
}
</script>

<style lang="scss">
@import '../../styles/variables';
@import '../../styles/mixins';

.welcome {
  &__title {
    font-size: 24px;
    font-weight: 900;
  }

  &__content {
    /*max-width: 600px;*/
  }
}

.stats {
  padding-top: 10px;

  .grid-x {
    margin: 0 -2px;
  }

  .cell {
    flex: none;
  }

  .label {
    margin: 0 2px 15px;
    padding-top: 15px;
    padding-bottom: 15px;
    text-align: left;
    width: 180px;

    &__heading {
      font-size: 16px;
      margin-bottom: 5px;
    }

    &__content {
      font-size: 18px;
      font-weight: 700;
    }
  }
}

@media (min-width: 641px) {
  .stats {
    padding-top: 0;

    .label {

      &__heading {
        font-size: 18px;
        margin-bottom: 5px;
      }

      &__content {
        font-size: 24px;
        font-weight: 700;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/vendorPortal/commissions.vue